import { render } from "./SignatureTab.vue?vue&type=template&id=ff7756bc"
import script from "./SignatureTab.vue?vue&type=script&lang=js"
export * from "./SignatureTab.vue?vue&type=script&lang=js"
script.render = render

export default script